

import { Button, Col, Row } from 'antd';
import './Template1.scss';
import LoginFormComponent from '../../../../../components/LoginForm/LoginForm';
import { Link } from 'react-router-dom';
import { GetDefaultLanguage, GetLanguageInUrl, ImagePath, IsLaguagePresentInUrl, IsSectionInPath } from '../../../../../utils/urls';
import { useEffect, useState } from 'react';
import { GetUserIcon } from '../../../../../utils/icons';
import { CarOutlined, EuroCircleOutlined, OrderedListOutlined, ShoppingCartOutlined, TagOutlined } from '@ant-design/icons';
import { useAppConfig } from '../../../../../Contexts/AppConfigContext';
import ShortCodeMethod from '../../../../../models/ShortCodeMethod';
import { useTranslation } from 'react-i18next';
import HTMLReactParser from 'html-react-parser';

interface Template1PageProps {
    shortCodeMethods?: ShortCodeMethod[]
}
const Template1Page = (props: Template1PageProps): JSX.Element => {
    const appConfig = useAppConfig();
    const {config, device} = appConfig;

    const { shortCodeMethods } = props;

    const [clientName, setClientName] = useState<string>(appConfig?.config?.clientData?.name || 'N/D');
    const [siteName, setSiteName] = useState<string>(appConfig?.config?.siteName || 'N/D');

    const [languageUrl, setlanguageUrl] = useState<string>();

    const [hotelList, setHotelList] = useState<any[]>();

    const imagePath = ImagePath();
    const { t } = useTranslation();

    const showModalLogin = (): void => {
        shortCodeMethods?.find((m) => m.name === 'openModalLogin')?.method();
    }





    useEffect(() => {
        if (appConfig?.config?.hotels) {
            // Usamos la función 'reduce' para agrupar los hoteles por ciudad
            const hotelsByCity = appConfig?.config?.hotels.reduce((acc: any, hotel: any) => {
                if (acc.hasOwnProperty(hotel.city)) {
                    acc[hotel.city].push(hotel);
                } else {
                    acc[hotel.city] = [hotel];
                }
                return acc;
            }, {});

            // Convertimos el objeto en un array de pares clave-valor
            const sortedHotels = Object.entries(hotelsByCity);

            // Ordenamos el array en función de las ciudades
            sortedHotels.sort((a, b) => a[0].localeCompare(b[0]));

            // Reconstruimos el objeto a partir del array ordenado
            const hotelsByCitySorted = sortedHotels.reduce((acc: any, [city, hotels]) => {
                acc[city] = hotels;
                return acc;
            }, {});

            setSiteName(appConfig?.config?.siteName || 'N/D');
            setClientName(appConfig?.config?.clientData?.name || 'N/D');

            setHotelList(hotelsByCitySorted);
        }
    }, [appConfig])




    useEffect(() => {
        var defaultLanguage = GetDefaultLanguage();

        if (IsLaguagePresentInUrl()) {
            setlanguageUrl(GetLanguageInUrl());
        } else {
            setlanguageUrl(defaultLanguage);
        }
    }, [])

    return (
        <div className="template-1">
            <div className="module-0">
                <div className="background" style={{ backgroundImage: `url(/images/theme-1-background-0.png)` }}>
                    <div className="filter-layout"></div>
                    <div className="color-layout"></div>
                    <div className="title">

                        {
                            HTMLReactParser(t('login-page.template-1.welcome', [config?.siteName || "N/D", config?.clientData?.name || 'N/D']))
                        }

                    </div>
                    <div className="actions">
                        <Link className="go-register" to={`${languageUrl}/register`}>
                            {t('login-page.template-1.register')}

                        </Link>
                        <Button className="go-login" onClick={showModalLogin}>
                            {t('login-page.template-1.login')}
                        </Button>
                    </div>
                </div>
            </div>
            <div className="module-1">
                <Row gutter={16} className="grid-row">
                    <Col className="grid-column text" xs={24} md={12}>
                        {HTMLReactParser(t('login-page.template-1.enjoy-advantages'))}
                    </Col>
                    <Col className="grid-column" xs={24} md={12}>
                        <div className="image-container" style={{ backgroundImage: `url(/images/grid1.png)` }} title="Disfrute de todas las ventajas como colaborador">
                        </div>
                    </Col>
                </Row>
                <Row gutter={16} className="grid-row">
                    <Col className="grid-column text" xs={24} md={12}>
                        {HTMLReactParser(t('login-page.template-1.manage'))}


                    </Col>
                    <Col className="grid-column" xs={24} md={12}>
                        <div className="image-container" style={{ backgroundImage: `url(/images/grid2.png)` }} title="Gestione desde esta plataforma susreservas y consultas">
                        </div>
                    </Col>
                </Row>
                <Row gutter={16} className="grid-row">
                    <Col className="grid-column" xs={24} md={12}>
                        <div className="image-container" style={{ backgroundImage: `url(/images/grid3.png)` }} title="Descubra las ventajas de {siteName}">
                        </div>
                    </Col>
                    <Col className="grid-column text" xs={24} md={12}>
                        {HTMLReactParser(t('login-page.template-1.discover-advantages', [siteName]))}
                    </Col>
                </Row>
                <Row gutter={16} className="grid-row">
                    <Col className="grid-column" xs={24} md={12}>
                        <div className="image-container" style={{ backgroundImage: `url(/images/grid4.png)` }} title="Únase a nuestro sistema de fidelización para agentes de viaje">
                        </div>
                    </Col>
                    <Col className="grid-column text" xs={24} md={12}>
                        {HTMLReactParser(t('login-page.template-1.loyalty-system'))}

                    </Col>
                </Row>
            </div>
            <div className="module-2">
                <img src={`/images/senator-summer-2023.png`} title="Hotel Brand HR Summer 2023" />
            </div>
            <div className="module-3">
                {HTMLReactParser(t('login-page.template-1.retribution-system'))}
                <Row gutter={16} className="grid-row">
                    <Col className="grid-column" xs={24} md={12}>
                        <div className="image-container" style={{ backgroundImage: `url(/images/grid5.png)` }}>
                        </div>
                    </Col>
                    <Col className="grid-column" xs={24} md={12}>
                        {HTMLReactParser(t('login-page.template-1.card-1', [siteName]))}



                    </Col>
                </Row>
                <Row gutter={16} className="grid-row">
                    <Col className="grid-column" xs={24} md={12}>
                        {HTMLReactParser(t('login-page.template-1.card-2', [siteName]))}

                    </Col>
                    <Col className="grid-column" xs={24} md={12}>
                        <div className="image-container" style={{ backgroundImage: `url(/images/grid6.png)` }}>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="module-4">
                <div className="background" style={{ backgroundImage: `url(/images/senator-background1.png)` }}>
                    <div className="filter-layout"></div>
                    <div className="title">
                        {HTMLReactParser(t('login-page.template-1.card-with-photo', []))}
                    </div>
                </div>
            </div>
            <div className="module-5">
                {HTMLReactParser(t('login-page.template-1.access-to', []))}
                <Row gutter={{ xs: 0, lg: 50 }}>
                    <Col xs={24} lg={12}>
                        <ul className="template1-list">
                            <li className="list-title">
                                <div><ShoppingCartOutlined className="list-icon" /></div>
                                {HTMLReactParser(t('login-page.template-1.easy-booking', []))}
                            </li>
                            <li className="list-description">
                                {HTMLReactParser(t('login-page.template-1.easy-booking-desc', []))}
                            </li>

                            <li className="list-title">
                                <div className="">
                                    <OrderedListOutlined className="list-icon" />
                                </div>
                                <div className="text">
                                    {HTMLReactParser(t('login-page.template-1.operations', []))}
                                </div>
                            </li>
                            <li className="list-description">

                                    {HTMLReactParser(t('login-page.template-1.operations-desc', []))}
                            </li>

                            <li className="list-title">
                                <div className="">
                                    <EuroCircleOutlined className="list-icon" />
                                </div>
                                <div className="text">
                                    {HTMLReactParser(t('login-page.template-1.rewards-system', []))}
                                </div>
                            </li>
                            <li className="list-description">
                                    {HTMLReactParser(t('login-page.template-1.rewards-system-desc', []))}                            
                            </li>

                            <li className="list-title">
                                <div className="">
                                    <TagOutlined className="list-icon" />
                                </div>
                                <div className="text">
                                    {HTMLReactParser(t('login-page.template-1.access-offers', []))}
                                </div>
                            </li>
                            <li className="list-description">
                                  {HTMLReactParser(t('login-page.template-1.access-offers-desc', []))}
                                
                            </li>
                        </ul>
                    </Col>
                    <Col xs={24} lg={12}>
                        <div className="login-container">
                                  {HTMLReactParser(t('login-page.template-1.log-in', []))}

                            <LoginFormComponent
                                onLogin={shortCodeMethods?.find((m) => m.name === 'onDoLogin')?.method as (userName: string, password: string) => void}
                                haveError={false}
                                doingLogin={false}
                                onForgetPassword={shortCodeMethods?.find((m) => m.name === 'onForgetPassword')?.method as () => void}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="module-6">
                <Row gutter={0} className="services">
                    <Col xs={24} md={6} className="service-box title">
                        {t('login-page.template-1.services')}
                    </Col>
                    <Col xs={24} md={6} className="service-box image">
                        <img src={`/images/service1.png`} />
                    </Col>
                    <Col xs={24} md={6} className="service-box image">
                        <img src={`/images/service2.png`} />
                    </Col>
                    <Col xs={24} md={6} className="service-box image">
                        <img src={`/images/service3.png`} />
                    </Col>
                </Row>

                <Row gutter={0} className="destinations">
                    <Col xs={24} md={6} className="service-box image">
                        <img src={`/images/destination1.png`} />
                    </Col>
                    <Col xs={24} md={6} className="service-box image">
                        <img src={`/images/destination2.png`} />
                    </Col>
                    <Col xs={24} md={6} className="service-box image">
                        <img src={`/images/destination3.png`} />
                    </Col>
                    <Col xs={24} md={6} className="service-box title">
                       {t('login-page.template-1.destinations')}
                    </Col>
                </Row>

            </div>
            <div className="module-7">
                <Row gutter={16}>
                    {
                        hotelList ?
                            Object.entries(hotelList!).map(([city, hotels]) => (
                                <Col xs={8} lg={6} key={city} className="city">
                                    <h2 className="city-name">{city}</h2>
                                    <ul className="hotel-list">
                                        {hotels?.map((hotel: any) => (
                                            <li key={hotel.name} className="hotel-name">
                                                {
                                                    hotel.link ? <a className="app-link no-hover no-underline" href={hotel.link} target='_blank'>{hotel.name}</a> : <>{hotel.name}</>
                                                }
                                            </li>
                                        ))}
                                    </ul>
                                </Col>
                            ))
                            :
                            <></>
                    }
                </Row>

            </div>
        </div>
    )
}

export default Template1Page;